export default class Event {
    constructor(
        id,
        triggerOn,
        deviceModelId,
        hardwareId,
        eventTypes,
        eventCategories,
        eventClassification,
        locations,
        speedPoints,
        headingPoints,
        isAccident,
        speedLimit,
        maxSpeed,
        speed,
        gSensorFrames,
        gyroscopeFrames,
        address,
        eventStatus,
        alarmKey,
        fromAlarm,
        vendorEventType,
        organizationId,
        organizationName,
        fleetId,
        fleetName,
        vehicleId,
        vehicleRegistrationNumber,
        driverId,
        driverName,
        isADAS,
        isDSM,
        isVisible = true,
    ) {
        this.id = id
        this.triggerOn = triggerOn
        this.deviceModelId = deviceModelId
        this.hardwareId = hardwareId
        this.eventTypes = eventTypes
        this.eventCategories = eventCategories
        this.eventClassification = eventClassification
        this.locations = locations
        this.speedPoints = speedPoints
        this.headingPoints = headingPoints
        this.isAccident = isAccident
        this.speedLimit = speedLimit
        this.maxSpeed = maxSpeed
        this.speed = speed
        this.gSensorFrames = gSensorFrames
        this.gyroscopeFrames = gyroscopeFrames
        this.address = address
        this.eventStatus = eventStatus
        this.alarmKey = alarmKey
        this.fromAlarm = fromAlarm
        this.vendorEventType = vendorEventType
        this.organizationId = organizationId
        this.organizationName = organizationName
        this.fleetId = fleetId
        this.fleetName = fleetName
        this.vehicleId = vehicleId
        this.vehicleRegistrationNumber = vehicleRegistrationNumber
        this.driverId = driverId
        this.driverName = driverName
        this.isADAS = isADAS
        this.isDSM = isDSM
        this.isVisible = isVisible
    }
}
